import { gql } from '@apollo/client';
import { apolloClient } from '../config/apollo-client';

export interface GameHistory {
  id: number;
  username: string;
  gameId: string;
  status: string;
  balanceStart: number | null;
  balanceEnd: number | null;
  createdAt: string;
}

export interface GameHistoryResponse {
  gameHistory: GameHistory[];
}

const GET_GAME_HISTORY = gql`
  query GetGameHistory($gameId: String!) {
    gameHistory(where: { gameId: $gameId, isDemo: false }) {
      id
      username
      gameId
      status
      balanceStart
      balanceEnd
      createdAt
    }
  }
`;

export const getGameHistory = async (
  gameId: string,
): Promise<GameHistory[]> => {
  try {
    const { data } = await apolloClient.query<GameHistoryResponse>({
      query: GET_GAME_HISTORY,
      variables: { gameId },
      fetchPolicy: 'network-only', // Always fetch fresh data
    });

    return data.gameHistory || [];
  } catch (error) {
    console.error('Error fetching game history:', error);
    throw error;
  }
};
